'use client'

import { DonationFormValues } from '@/donationForm/types'
import { WithFormValues } from '@/form/ActionForm/RequiredField/RequiredField'
const DonationFormRequiredField = WithFormValues<DonationFormValues>()
export default DonationFormRequiredField
